import api from "./api";

export interface ThemeData {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  css_variables: Record<string, string>;
  is_system: boolean;
  is_active: boolean;
  sort_order: string;
  created_at: string;
  updated_at: string;
  users_count: number;
}

export interface ThemeListResponse {
  themes: ThemeData[];
  total_count: number;
}

export const themeService = {
  listThemes: async (): Promise<ThemeListResponse> => {
    const { data } = await api.get<ThemeListResponse>("/themes");
    return data;
  },

  getTheme: async (id: string): Promise<ThemeData> => {
    const { data } = await api.get<ThemeData>(`/themes/${id}`);
    return data;
  },

  setMyTheme: async (themeId: string): Promise<{ message: string; theme_id: string }> => {
    const { data } = await api.put("/themes/me", { theme_id: themeId });
    return data;
  },
};
